<div class="productAdd seedAddProduct d-flex">
  <div class="account-sidebar" *ngIf="selectedData && !isFromGoBack">
    <div class="account-sidebar__header">
      <div class="account-sidebar__section">
        <h4 class="account-sidebar__title">Account:</h4>
        <p class="account-sidebar__name">{{selectedData.shipToName}}</p>
        <p class="account-sidebar__detail">
          {{selectedData.shipToAccountAddress1}}, {{selectedData.shipToCity}}, {{selectedData.shipToState}} - {{selectedData.shipToZipCode}}
        </p>
        <p class="account-sidebar__detail">{{selectedData.shipToContact}}</p>
        <p class="account-sidebar__detail">Account #: {{selectedData.accountNo}}</p>
      </div>
      <h4 class="account-sidebar__title mb-1">Grower:</h4>
      <div class="sidebarSelect" [ngClass]="growerList?.length <= 1 ? 'selectNoBorder' : 'selectBorder'">
        <div class="material-select withBordr productLabelAccountName">
          <ng-select name="ddlgrower"
                     [items]="growerList"
                     class="custom-select-grower grower-add-drop"
                     [ngClass]="{'grower-readonly': growerList?.length <= 1}"
                     [virtualScroll]="true"
                     bindValue="gmk"
                     [(ngModel)]="selectedData.gmk"
                     (change)="onGrowerChange($event)"
                     [closeOnSelect]="true"
                     [disabled]="growerList?.length <= 1"
                     [searchFn]="growerSearchFn"
                     data-testid="ddl-ship-to-search">

            <!-- Custom selected label -->
            <ng-template ng-label-tmp let-item="item">
              <div class="selected-template">
                <p class="greenColor m-0">{{item.businessName?.toUpperCase()}}</p>
                {{item.address1?.toUpperCase()}}, {{item.city?.toUpperCase()}},<br /> {{item.state?.toUpperCase()}} - {{ item.zip?.toUpperCase() }}<br />
                GMK: {{ item.gmk }}<br />
                GLN: {{ item.growerGLN }}
              </div>
            </ng-template>

            <!-- Dropdown option template stays the same -->
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-shipto-return-option_'+index">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="name" [ngOptionHighlight]="search">
                      {{item.businessName?.toUpperCase()}}
                    </h4>
                    <p class="address m-0" [ngOptionHighlight]="search">
                      {{item.address1?.toUpperCase()}}, {{item.city?.toUpperCase()}},<br />  {{item.state?.toUpperCase()}} - {{ item.zip?.toUpperCase() }}<br />
                    </p>
                    <p class="grower-nos m-0">
                      <span class="grower-gln" [ngOptionHighlight]="search">
                        GMK: {{ item.gmk }}
                        GLN: {{ item.growerGLN }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="account-sidebar__section">
        <h4 class="account-sidebar__title">Seller:</h4>
        <p class="account-sidebar__name">{{selectedData.sellerName}}</p>
      </div>
    </div>


    <div class="account-sidebar_footer">
      <div class="account-sidebar__section footerSection">
        <!-- <h4 class="account-sidebar__title">Order Info</h4> -->
        <div class="account-sidebar__stat growerColumn">
          <span class="account-sidebar__stat-labelGrower">  {{ selectedData.growerOrderNumber ? 'Grower Order #': 'New Grower Order' }}</span>
          <span class="account-sidebar__stat-value grower-order-value">{{selectedData.growerOrderNumber}}</span>
        </div>
        <div class="account-sidebar__stat growerColumn">
          <span class="account-sidebar__stat-label">Reservation Units</span>
          <span class="account-sidebar__stat-value unitsBox reserveUnits">{{reservationUnits | number}}</span>
        </div>
        <div class="account-sidebar__stat growerColumn">
          <span class="account-sidebar__stat-label">Units Selected</span>
          <span class="account-sidebar__stat-value unitsBox selectedUnits">{{unitSelected | number}}</span>
        </div>
        <div class="account-sidebar__stat growerColumn">
          <span class="account-sidebar__stat-label">Pending Reservation Units</span>
          <span class="account-sidebar__stat-value unitsBox reserveUnits">{{remainingReservationUnit | number}}</span>
        </div>
      </div>
      <div class="account-sidebar__actions">
        <button mat-raised-button class="btns account-sidebar__btn" color="primary" [disabled]="selectedProductList.length <=0 " (click)="AddProducts()">Add to Order</button>
      </div>
    </div>
  </div>
  <div>
    <h3>Add Product(s) to the order</h3>
    <div class="form-sec">
      <div class="row margin-r0">
        <div class="col-md-10 col-lg-11 smallPadRgt0">
          <div class="row search-box-outer">
            <div class="col-4 col-md-3 padding-r0 border-right padding-l0">
              <div class="brand-dropdown material-select d-none d-md-block">
                <ng-select name="ddlProductSearch"
                           [(ngModel)]="selectedValue"
                           (ngModelChange)="enableDisableSearch()"
                           [virtualScroll]="true"
                           [closeOnSelect]="true"
                           [selectOnTab]="true"
                           [clearable]="false"
                           [searchable]="false"
                           labelForId="name"
                           (change)="keepFilter()"
                           data-testid="ddl-itemNumber-search">
                  <ng-option *ngFor="let data of searchTypeList;let index=index" [value]="data">
                    <span [attr.data-testid]="'ddl-search-select_'+index">{{data}}</span>
                  </ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-8 col-md-9 padding-l0 padding-r0">
              <div class="material-select sales-search">
                <ng-select #itemNumber name="ddlItemNoSearch" *ngIf="selectedValue === 'Item Number'"
                           [items]="itemNumberList"
                           placeholder="Search Product"
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.ItemNoList"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p>
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>

                <div #productSearch *ngIf="selectedValue === 'Product Name'">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter();getProducts();" [(ngModel)]="productFilters.Brand" (ngModelChange)="validateProductSearch()"
                               placeholder="Search Product" type="text">
                      </div>
                    </div>
                  </div>
                </div>
                <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Seed Size'"
                           [items]="seedsizeMasterList"
                           placeholder="Search Product"
                           [multiple]="true"
                           [hideSelected]="true"
                           class="custom-select-grower"
                           [(ngModel)]="productFilters.SeedSizeList"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p>
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
                <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Package Size'"
                           [items]="packagesizeMasterList"
                           placeholder="Search Product"
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.PackageSizeList"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p>
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
                <div #productSearch *ngIf="selectedValue === 'Technology'">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter();getProducts();" [(ngModel)]="productFilters.TechnologyList" (ngModelChange)="validateTechnologySearch()"
                               placeholder="Search Technology" type="text">
                      </div>
                    </div>
                  </div>
                </div>
                <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Treatment'"
                           [items]="treatmentMasterList"
                           placeholder="Search Product"
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.TreatmentList"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p>
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
                <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Maturity'">
                  <ng-select #productSearch name="ddlproductSearch"
                             [items]="maturityMasterList"
                             placeholder="Min"
                             class="custom-select-grower "
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.MaturityMin"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="keepFilter()">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p>
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Maturity'">
                  <ng-select #productSearch name="ddlproductSearch"
                             [items]="maturityMasterList"
                             placeholder="Max"
                             class="custom-select-grower"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.MaturityMax"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="keepFilter()">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p>
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="col-md-2 col-lg-1 col-sm-12 search-btn-outer text-center padding-sm-l15 padding-sm-r0">
          <div class="search-btn">
            <button mat-raised-button class="btns wide-sm-100 margin-t12 margin-sm-t10" color="primary" (click)="keepFilter();getProducts()" [disabled]="isTextBoxEmpty" data-testid="btn-orderfilter-search">Search</button>
          </div>
        </div>
      </div>
      <div class="d-flex showProdSec justify-content-end xs-p-10 row">

        <div class="col-6 col-md-3">
          <div class="row">
            <div class="col-9 m-auto">Only show product on Dealer Order</div>
            <mat-checkbox class="custom-checkbox col-3" #chkDealerOrderAvailability [(ngModel)]="productFilters.IsRelatedtoDealerItemsOnly"></mat-checkbox>
          </div>
        </div>

        <div class="xs-pl-20 col-6 col-md-3">
          <div class="row">
            <div class="col-9 m-auto">Only show product with availability</div>
            <mat-checkbox class="custom-checkbox col-3" #chkAvailability [(ngModel)]="productFilters.IsAvailabilityChecked"></mat-checkbox>
          </div>
        </div>
      </div>
      <div class="row chips-sec" *ngIf="filterValueList.length > 0">
        <div class="col-sm-9 selected-chip">
          <mat-chip-set>
            <mat-chip selected *ngFor="let filterValue of filterValueList" [ngClass]="{ 'readonly-filter': isDefaultFilter(filterValue) }">
              {{filterValue}}
              <a *ngIf="!isDefaultFilter(filterValue)"
                 href="Javascript:void(0);"
                 (click)="clearFilter(filterValue)">
                <i class="fas fa-times text-right"></i>
              </a>
            </mat-chip>
          </mat-chip-set>
        </div>
        <div class="col-sm-3 text-right padding-r20" *ngIf="filterValueList.length > 0">
          <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
        </div>
      </div>
    </div>
    <div class="reconcile-slider-body">
      <div class="reconcile-slider-table-area">
        <div class="row">
          <div class="col-md-12">
            <div class="tableContainer table-mobile-landing">
              <table mat-table #productsTable [dataSource]="productDataSource" class="matTables">
                <!-- Position Column -->
                <ng-container matColumnDef="SeedAvailability">
                  <th mat-header-cell *matHeaderCellDef class="text-center" title="Availability">Avail.</th>
                  <td mat-cell *matCellDef="let element" class="available-block text-center" (click)="removeSelectedRow(element)">
                    <div class="mobileText">Avail.</div>
                    <span class="seed-avail">
                      {{element.seedAvailability | number}}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="NetBEU">
                  <th mat-header-cell *matHeaderCellDef class="text-center" title="Dealer Order">DO</th>
                  <td mat-cell *matCellDef="let element" class="available-block text-center" (click)="removeSelectedRow(element)">
                    <div class="mobileText">DO</div>
                    <span class="seed-avail">
                      {{element.netBEU | number}}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="DealerBucket">
                  <th mat-header-cell *matHeaderCellDef class="text-center" title="My Dealer Bucket"> MDB </th>
                  <td mat-cell *matCellDef="let element" class="available-block text-center" (click)="removeSelectedRow(element)">
                    <div class="mobileText">MDB</div>
                    <span>
                      <span class="seed-avail" *ngIf="element.myDealerBucket>=0">{{commonService.getFormatedNumber(element.myDealerBucket) | number}}</span>
                      <span class="seed-avail" *ngIf="element.myDealerBucket<0">({{commonService.getFormatedNumber(element.myDealerBucket | positiveValue) | number}})</span>
                    </span>
                  </td>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="Product Name">
                  <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name </th>
                  <td mat-cell *matCellDef="let element" class="order-info d-sm-block d-md-table-cell product-line" id="td-ProductDetail" [attr.data-testid]="element.itemNumber" (click)="removeSelectedRow(element)">
                    <p class="d-block d-md-none padding-l5">Product</p>
                    <span>
                      <p><a matTooltip="{{element.itemNumber}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">{{element.brand}} - {{element.marketingBrand}}</a> </p>
                      <p class="grower-name">
                        <a>
                          {{element.itemDescription}}
                        </a>
                      </p>
                    </span>
                    <p *ngIf="element.seedNonReturnable" class="nonReturnable"> <a>*NON-RETURNABLE </a></p>
                    <div class="checkBoxOuterBg margin-t10 d-md-none">
                      <div class="chkboxOuter">
                        <i class="fas fa-check checkShowHide"></i>
                        <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.isProductSelected" *ngIf="element.isProductSelected && (element.isProductDeactivated == false || (element.deactivationType == null || element.deactivationType.trim().toLowerCase() != 'suspend'))"></mat-checkbox>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="Pack Size">
                  <th mat-header-cell *matHeaderCellDef class="text-center"> Pack Size </th>
                  <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell" (click)="removeSelectedRow(element)">
                    <span class="oval-shape" [ngClass]="{'pack-size': (element.highlightPackage===1)}" matTooltip="{{element.packageSize}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                      {{element.packageSize}}
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="Seed Size">
                  <th mat-header-cell *matHeaderCellDef class="text-center"> Seed Size </th>
                  <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell" (click)="removeSelectedRow(element)"> {{element.seedSize}}  </td>
                </ng-container>

                <ng-container matColumnDef="Technology">
                  <th mat-header-cell *matHeaderCellDef class="text-center"> Technology </th>
                  <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell" (click)="removeSelectedRow(element)">
                    <span class="oval-shape" [ngClass]="{'technology': (element.highlightTechnology===1)}" matTooltip="{{element.technology}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                      {{element.technology}}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="Treatment">
                  <th mat-header-cell *matHeaderCellDef class="text-center"> Treatment </th>
                  <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell" (click)="removeSelectedRow(element)">
                    <span class="oval-shape" [ngClass]="{'treatment': (element.highlightTreatment===1)}" matTooltip="{{element.treatment}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                      {{element.treatment}}
                    </span>
                  </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="Maturity">
                  <th mat-header-cell *matHeaderCellDef class="text-center"> Maturity </th>
                  <td mat-cell *matCellDef="let element; let i=index" class="text-center d-none d-md-table-cell" [attr.data-testid]="'ddl-maturity-check_'+i" (click)="removeSelectedRow(element)"> {{element.maturity}} </td>
                </ng-container>

                <!-- Units -->
                <ng-container matColumnDef="Units">
                  <th mat-header-cell *matHeaderCellDef class="text-center"> Units </th>
                  <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell">
                    <div class="d-flex align-items-center justify-content-center" *ngIf="!((element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend')))">
                      <button (click)="geuValueChange('decrease',element);" class="plus-minus-btn minusBtn" [attr.data-testid]="'decrease-' + element.itemNumber">
                        -
                      </button>
                      <input #unitsInput class="geu-txt decimal-txt unitsText"
                             id="txtUnits"
                             type="text"
                             [(ngModel)]="element.reservationUnits"
                             [ngClass]="{'invalid-txt': (element.reservationUnits==0 && element.growerOrderItemId==0)}"
                             maxlength="9"
                             appThreeDigitDecimaNumber
                             [disabled]="element.isProductDeactivated === true && (element.deactivationType == null || element.deactivationType.trim().toLowerCase() == 'suspend')" (keyup)="geuTextChange(element)"
                             [attr.data-testid]="'qty-' + element.itemNumber" />
                      <button *ngIf="!((element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend')))"
                              (click)="geuValueChange('increase',element);" class="plus-minus-btn plusBtn" [attr.data-testid]="'increase-' + element.itemNumber">
                        +
                      </button>

                    </div>
                    <div *ngIf="((element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend')))" class="unitsText disabledInputText text-center">
                      {{commonService.getFormatedNumber(element.reservationUnits) | number}}
                    </div>
                  </td>
                </ng-container>


                <!-- delivery date -->
                <ng-container matColumnDef="Delivery Date">
                  <th mat-header-cell *matHeaderCellDef class="text-center"> Delivery Date </th>
                  <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell">
                    <div class="date-input-wrapper m-auto">
                      <mat-form-field class="w-100">
                        <input matInput class="delivery-date-input" [readonly]="element.isProductDeactivated === true && (element.deactivationType == null || element.deactivationType.trim().toLowerCase() == 'suspend')"
                               [matDatepicker]="picker" (focus)="picker.open();" [matDatepickerFilter]="dateFilter"
                               [(ngModel)]="element.desiredDeliveryDate" (dateChange)="syncSelectedItem(element)" disabled>
                        <mat-datepicker-toggle [id]="'ddl-date-picker_'+i" matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker [disabled]="element.isProductDeactivated === true && (element.deactivationType == null || element.deactivationType.trim().toLowerCase() == 'suspend')"></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="Product Line">
                  <th mat-header-cell *matHeaderCellDef class="text-center"> Product Line </th>
                  <td mat-cell *matCellDef="let element" class="product-line text-center d-none d-md-table-cell" (click)="removeSelectedRow(element)">
                    <div class="checkBoxOuterBg">
                      <div class="chkboxOuter">
                        <i class="fas fa-check checkShowHide"></i>
                        <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.isProductSelected" *ngIf="element.isProductSelected && (element.isProductDeactivated == false || (element.deactivationType == null || element.deactivationType.trim().toLowerCase() != 'suspend'))"></mat-checkbox>
                      </div>
                    </div>
                    <span>
                      {{element.productLine}}
                    </span>
                    <div class="unavailableMsg" *ngIf="element.isProductDeactivated === true && (element.deactivationType == null || element.deactivationType.trim().toLowerCase() == 'suspend')">
                      <div id="main_{{element.itemNumber}}">
                        <div class="unavail-content" id="sub_{{element.itemNumber}}">
                          <h4>This item is currently unavailable for ordering.</h4>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;" class="d-none d-md-table-row"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'active':row.isProductSelected}"></tr>
              </table>
              <!--<mat-paginator #productPaginator [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row add-order-sec margin-l0 margin-r0 justify-content-end">
       <button *ngIf="isFromGoBack"
              type="button"
              mat-raised-button
              class="btns submitBtns mr-auto wide-sm-100 w140 font-sm-14"
              color="primary"
              [disabled]="selectedProductList.length <= 0"
              (click)="AddProducts()">
        Add to Order
      </button>
      <div>PRODUCTS SELECTED: <span class="count">{{selectedProductList.length}}</span></div>
    </div>
  </div>
</div>
